import { apiPath } from "../../constants";
import {
    axios,
    apiRequestHeaders,
    apiRequestPath,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const PROFILE_REQUEST = 'FETCH_PROFILE_REQUEST';
export const PROFILE_FAILURE = 'FETCH_PROFILE_FAILURE';
export const PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';

export const fetchOwnProfile = () => {
    return function(dispatch) {
        dispatch(fetchProfileRequest());

        const api = apiPath.USER.OWN_PROFILE;
        const requestOptions = {
            method: api.method,
            url: apiRequestPath(api.path),
            headers: apiRequestHeaders(true),
            json: true
        };

        return axios(requestOptions)
            .then(transformHttpResponse)
            .then(response => dispatch(fetchProfileSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchProfileFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchProfileRequest = () => {
    return {
        type: PROFILE_REQUEST,
    }
};

const fetchProfileFailure = (error) => {
    return {
        type: PROFILE_FAILURE,
        error,
    }
};

const fetchProfileSuccess = (data) => {
    return {
        type: PROFILE_SUCCESS,
        data,
    }
};